import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const OrderSuccessModal = ({ orderId, onClose }) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleCopyOrderId = () => {
    navigator.clipboard.writeText(orderId);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-light-surface dark:bg-dark-surface p-8 rounded-2xl shadow-2xl w-11/12 sm:w-96 animate-fadeInDown border border-light-border dark:border-dark-border">
        {/* Icon with Gradient Background */}
        <div className="flex justify-center">
          <div className="p-4 bg-gradient-to-br from-primary to-secondary rounded-full animate-bounce">
            <FaCheckCircle className="w-16 h-16 text-white" />
          </div>
        </div>

        {/* Title */}
        <h2 className="mt-6 text-3xl font-bold text-center bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          🎉 Success!
        </h2>

        {/* Order ID */}
        <div className="mt-4 text-center">
          <p className="text-light-text-secondary dark:text-dark-text-secondary">Your order ID:</p>
          <span className="block mt-2 font-bold text-light-text-primary dark:text-dark-text-primary text-xl">
            {orderId}
          </span>
        </div>

        {/* Buttons */}
        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={handleCopyOrderId}
            className="px-6 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-full 
                      hover:from-primary-hover hover:to-secondary-hover transition-all transform 
                      hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary/50"
          >
            {isCopied ? 'Copied!' : 'Copy Order ID'}
          </button>
          <button
            onClick={onClose}
            className="px-6 py-2 border-2 border-light-border dark:border-dark-border 
                      text-light-text-primary dark:text-dark-text-primary rounded-full 
                      hover:bg-light-background dark:hover:bg-dark-background 
                      transition-all transform hover:scale-105 focus:outline-none"
          >
            Close
          </button>
        </div>

        {/* Footer Message */}
        <div className="mt-6 text-center text-light-text-secondary dark:text-dark-text-secondary text-sm">
          We're on it! Stay tuned for updates. 🚀
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessModal;